export default __webpack_public_path__ + "static/media/refresh.a408cdd2.svg";